// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;&#145;Though the earth reels and all that dwell in her,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;it is I that hold her pillars steady.<br> </p> </div></div>";
// Exports
module.exports = code;